export const COGNITO_GROUP_NAMES = {
  CUSTOMER_STATISTICS: "CUSTOMER_STATISTICS",
  INTERNAL_SPARXS_EDITOR: "INTERNAL_SPARXS_EDITOR",
  INTERNAL_UTIL: "INTERNAL_UTIL",
} as const;
